<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="65%" @close="handleClose"
      append-to-body>
      <el-container class="container" direction="vertical">
        <!-- 患者基本信息 -->
        <el-descriptions :column="4" border style="margin-bottom: 16px;">
          <el-descriptions-item label="患者姓名" span="2">{{ formData.patientName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="登记号" span="2">{{ formData.recordNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="性别" span="1">{{ displayGender(formData.gender) }}</el-descriptions-item>
          <el-descriptions-item label="年龄" span="1">{{ formData.age || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系方式" span="2">{{ formData.phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="身份证号" span="2">{{ formData.idcard || '-' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 管理方案信息 -->
        <el-descriptions :column="4" border style="margin-bottom: 16px;">
          <template slot="title">
            <strong>管理方案信息</strong>
          </template>
          <el-descriptions-item label="管理标签" span="2">
            {{ form.managementTag || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="手术情况" span="2">
            <span v-if="readonly">{{ displayValue(form.surgeryStatus) }}</span>
            <el-select v-else v-model="form.surgeryStatus" placeholder="请选择" style="width:100%">
              <el-option v-for="(x, index) in surgicalSituationList" :key="index" :label="x.label" :value="x.value" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="病理类型" span="2">
            <span v-if="readonly">{{ displayValue(form.pathologicalType) }}</span>
            <el-select v-else v-model="form.pathologicalType" placeholder="请选择" style="width:100%">
              <el-option v-for="(x, index) in pathologicalTypeList" :key="index" :label="x.label" :value="x.value" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="复查到期时间" span="2">
            <span v-if="readonly">{{ displayValue(form.reviewDueDate) }}</span>
            <el-date-picker v-else v-model="form.reviewDueDate" type="date" placeholder="选择复查到期时间" style="width:100%"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="随诊建议*" span="4">
            <span v-if="readonly">{{ displayValue(form.followUpSuggestion) }}</span>
            <el-select v-else v-model="form.followUpSuggestion" placeholder="请选择随诊建议" style="width:100%">
              <el-option v-for="(item, index) in followupSuggestionsList" :key="index" :label="item.label"
                :value="item.label" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="备注" span="4">
            <span v-if="readonly" class="detail-text">{{ displayValue(form.remarks) }}</span>
            <el-input v-else type="textarea" v-model="form.remarks" :rows="2" placeholder="请输入备注"></el-input>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 随访信息 -->
        <el-descriptions :column="4" border style="margin-bottom: 16px;">
          <template slot="title">
            <strong>随访信息</strong>
          </template>
          <el-descriptions-item label="电话接通情况" span="2">
            <span v-if="readonly">{{ displayValue(form.phoneResult) }}</span>
            <el-select v-else v-model="form.phoneResult" placeholder="请选择电话接通情况" style="width:100%">
              <el-option v-for="item in phoneResultOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="患者依从性" span="2">
            <span v-if="readonly">{{ displayValue(form.patientCompliance) }}</span>
            <el-select v-else v-model="form.patientCompliance" placeholder="请选择患者依从性" style="width:100%">
              <el-option v-for="item in complianceOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="患者意向" span="4">
            <span v-if="readonly" class="detail-text">{{ displayValue(form.patientIntention) }}</span>
            <el-input v-else type="textarea" v-model="form.patientIntention" :rows="2"
              placeholder="请输入患者意向"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="随访备注" span="4">
            <span v-if="readonly" class="detail-text">{{ displayValue(form.annotation) }}</span>
            <el-input v-else type="textarea" v-model="form.annotation" :rows="2" placeholder="请输入随访备注"></el-input>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 随访人信息（自动填充） -->
        <el-descriptions :column="4" border>
          <template slot="title">
            <strong>随访人信息</strong>
          </template>
          <el-descriptions-item label="随访人" span="2">{{ userInfos.name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="随访机构" span="2">{{ userInfos.hospitalName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="随访科室" span="2">{{ userInfos.deptName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="随访机构电话" span="2">{{ userInfos.hospitalPhone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="随访时间" span="2">{{ userInfos.codiagTime || '-' }}</el-descriptions-item>
        </el-descriptions>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ readonly ? '关闭' : '取消' }}</el-button>
        <el-popconfirm v-if="!readonly" title="是否确认提交？" @confirm="handleSubmit">
          <el-button slot="reference" type="primary" :loading="submitting">提交随访单</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>

    <el-dialog v-if="!readonly" title="终止一体化管理" :visible.sync="terminationDialogVisible" width="500px"
      :close-on-click-modal="false" append-to-body>
      <el-alert title="未填写复查时间，提交后将终止该患者的一体化管理" type="warning" :closable="false"
        show-icon style="margin-bottom: 16px;" />
      <el-form>
        <el-form-item label="终止原因" required>
          <el-input v-model="terminationReason" type="textarea" :rows="4" maxlength="500" show-word-limit
            placeholder="请输入终止一体化管理的原因" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="terminationDialogVisible = false">取消</el-button>
        <el-button type="danger" :loading="submitting" @click="confirmTermination">确认终止并提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfos, getSysDicList } from "@/api/health/Patients";
import { postListLungDetail, submitLungcancerFollowup, getCancerManagePlanByIdcard, getLungcancerFollowupByRecordId } from "@/api/health/Lung";
import { validateFollowupSubmission, normalizeTerminationReason, buildReadonlyFollowupDetail, buildFollowupSubmission, displayFollowupValue, displayGender } from "@/utils/lung-followup-form";

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showDialog: false,
      title: "肺结节随访单",
      form: {
        managementTag: null,
        surgeryStatus: null,
        pathologicalType: null,
        followUpSuggestion: null,
        reviewDueDate: null,
        remarks: null,
        phoneResult: null,
        patientCompliance: null,
        patientIntention: null,
        annotation: null,
      },
      resetForm: {
        managementTag: null,
        surgeryStatus: null,
        pathologicalType: null,
        followUpSuggestion: null,
        reviewDueDate: null,
        remarks: null,
        phoneResult: null,
        patientCompliance: null,
        patientIntention: null,
        annotation: null,
      },
      formData: {},
      userInfos: {},
      followupSuggestionsList: [],
      terminationDialogVisible: false,
      terminationReason: null,
      submitting: false,
      phoneResultOptions: ["已接听", "未接听", "拒接", "空号", "停机"],
      complianceOptions: ["配合", "不配合"],
      surgicalSituationList: [
        { label: "未手术", value: "未手术" },
        { label: "已手术", value: "已手术" }
      ],
      pathologicalTypeList: [
        { label: "腺癌", value: "腺癌" },
        { label: "鳞癌", value: "鳞癌" },
        { label: "小细胞肺癌", value: "小细胞肺癌" },
        { label: "大细胞肺癌", value: "大细胞肺癌" },
        { label: "其他", value: "其他" }
      ],
    }
  },
  methods: {
    displayGender,
    displayValue(value) {
      return displayFollowupValue(value);
    },
    formatDateOnly(value) {
      if (!value) return null;
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) {
        const text = String(value);
        return text.length >= 10 ? text.slice(0, 10) : text;
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async init(value) {
      this.formData = { ...value };
      this.title = this.readonly ? "肺结节随访详情" : "肺结节随访单";

      if (this.readonly) {
        try {
          const res = await getLungcancerFollowupByRecordId({ followupRecordId: value?.id });
          if (res.msg !== 'success' || !res.data) {
            this.$message.error(res.msg || '未找到对应的肺结节随访详情');
            return;
          }
          const detail = buildReadonlyFollowupDetail(res.data);
          this.form = { ...this.resetForm, ...detail.form };
          this.userInfos = {
            name: detail.userInfos.realName,
            hospitalName: detail.userInfos.hospitalName,
            deptName: detail.userInfos.deptName,
            hospitalPhone: detail.userInfos.phone,
            codiagTime: detail.userInfos.followupTime,
          };
          this.showDialog = true;
        } catch (error) {
          console.log(error);
          this.$message.error('查询肺结节随访详情失败');
        }
        return;
      }

      // 与纳入管理表单使用同一套随诊建议字典
      this.getFollowupSuggestions();
      // 获取病理和手术信息
      this.loadListLungDetail({ idcard: value?.idcard });
      // 先带入列表中的复查到期时间，避免管理方案尚未返回时表单空白
      if (value?.reviewExpireTime) {
        this.form.reviewDueDate = this.formatDateOnly(value.reviewExpireTime);
      }
      // 默认代入当前管理方案
      if (value?.idcard) {
        getCancerManagePlanByIdcard({ idcard: value.idcard }).then(res => {
          if (res.msg === 'success' && res.data) {
            const plan = res.data;
            this.form.managementTag = plan.managementTag || null;
            this.form.surgeryStatus = plan.surgeryStatus || null;
            this.form.pathologicalType = plan.pathologicalType || null;
            this.form.followUpSuggestion = plan.followUpSuggestion || null;
            this.form.reviewDueDate = this.formatDateOnly(plan.reviewDueDate || value.reviewExpireTime);
            this.form.remarks = plan.remarks || null;
          }
        }).catch(err => console.log(err));
      }
      // 获取用户信息
      getUserInfos({}).then((res) => {
        if (res.msg == "success") {
          this.userInfos.name = res.data.name || '';
          this.userInfos.hospitalPhone = res.data.hospitalPhone || '';
          this.userInfos.hospitalName = res.data.hospitalName || '';
          this.userInfos.deptName = res.data.deptName || '';
          this.getSystemTime();
          this.showDialog = true;
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    getFollowupSuggestions() {
      getSysDicList({ typeName: '肺结节协诊' }).then(res => {
        if (res.msg === 'success') {
          this.followupSuggestionsList = (res.data?.records || []).map(item => ({
            label: item.name,
            value: item.value
          }));
        }
      }).catch(err => console.log(err));
    },
    loadListLungDetail(props) {
      const { idcard } = props;
      if (!idcard) return;
      postListLungDetail({ ...props }).then(res => {
        this.surgicalSituationList = [{ label: "未手术", value: "未手术" }, { label: "已手术", value: "已手术" }];
        this.pathologicalTypeList = [{ label: "腺癌", value: "腺癌" }, { label: "鳞癌", value: "鳞癌" }, { label: "小细胞肺癌", value: "小细胞肺癌" }, { label: "大细胞肺癌", value: "大细胞肺癌" }, { label: "其他", value: "其他" }];
        if (res.data && res.data.length > 0) {
          const surgeryOptions = res.data.map(x => ({
            label: x.surgery_name_main,
            value: x.surgery_name_main
          })).filter(x => x.label);
          if (surgeryOptions.length > 0) {
            this.surgicalSituationList = [{ label: "未手术", value: "未手术" }, ...surgeryOptions];
          }
          const pathologyOptions = res.data.map(x => ({
            label: x.diag_name_pathology,
            value: x.diag_name_pathology
          })).filter(x => x.label);
          if (pathologyOptions.length > 0) {
            this.pathologicalTypeList = [{ label: "无", value: "无" }, ...pathologyOptions];
          }
        }
      }).catch(err => console.log(err));
    },
    getSystemTime() {
      const time = new Date();
      const year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      const hour = time.getHours().toString().padStart(2, '0');
      const minute = time.getMinutes().toString().padStart(2, '0');
      const second = time.getSeconds().toString().padStart(2, '0');
      this.userInfos.codiagTime = `${year}-${month}-${date} ${hour}:${minute}:${second}`;
    },
    handleSubmit() {
      const decision = validateFollowupSubmission({
        followUpSuggestion: this.form.followUpSuggestion,
        reviewDueDate: this.form.reviewDueDate
      });
      if (decision.error) {
        this.$message.error(decision.error);
        return;
      }
      if (decision.requiresTermination) {
        this.terminationReason = null;
        this.terminationDialogVisible = true;
        return;
      }
      this.submitFollowup(null);
    },
    confirmTermination() {
      const reason = normalizeTerminationReason(this.terminationReason);
      if (!reason) {
        this.$message.error('请填写终止管理原因');
        return;
      }
      this.submitFollowup(reason);
    },
    submitFollowup(terminationReason) {
      if (this.submitting) return;
      const submitData = buildFollowupSubmission({
        patient: this.formData,
        form: this.form,
        userInfos: this.userInfos,
        terminationReason,
      });

      this.submitting = true;
      submitLungcancerFollowup(submitData).then(res => {
        if (res.msg === 'success') {
          this.$message({ message: "肺结节随访单提交成功！", type: "success" });
          this.$emit("upDataList");
          this.handleClose();
        } else {
          this.$message({ message: res.msg || "提交失败！", type: "error" });
        }
      }).catch(err => {
        console.log(err);
        this.$message({ message: "提交失败！", type: "error" });
      }).finally(() => {
        this.submitting = false;
      });
    },
    handleClose() {
      this.form = { ...this.resetForm };
      this.terminationDialogVisible = false;
      this.terminationReason = null;
      this.showDialog = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-height: 600px;
  overflow-y: auto;
}

.detail-text {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
